import { Component, OnInit } from '@angular/core';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '@app/shared/services/order/order.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RatingReviewDialogComponent } from '../../rating-review-dialog/rating-review-dialog.component';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { TrackingPopupComponent } from '@app/shared/components/orders/tracking-popup/tracking-popup.component';
import { EncrDecrService } from '../../../services/encr-decr-service.service';
import { Constants, CryptoKeyValue, ReportOrderRequestStatus } from '../../../constants';
import { ReportOrderComponent } from '@app/shared/dialogs/report-order/report-order.component';
import { CommonService } from '@app/shared/services/common/common.service';
import { OrderCancelComponent } from '../../order-cancel/order-cancel.component';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';
import { TransactionDetailDialogComponent } from '../../../dialogs/transaction-detail/transaction-detail.component';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css']
})
export class OrderDetailComponent implements OnInit {
  rate!: number;
  orderDetail !: any;
  orderlog!: any;
  orderDeskNo = null;
  orderId = null;
  userRole!: any;
  userId!: any;
  orderid!: any;
  storeId!: any;
  selectedValue: any;
  parentRouteParam !: any;
  totalPrintCost = 0;
  cartTotal = 0;
  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL = environment.productCustomImageFolder;
  imgWareHouseBaseURL =  environment.warehouseProductCustomImageFolder;
  shopifyTotal = 0;
  // SOP-hosted discount summary (shown below "Amount Paid" for SOP-hosted orders only)
  isSopHosted = false;
  sopHostedDiscountPercent = 0;
  sopHostedDiscountAmount = 0;
  sopHostedFinalTotal = 0;
  amountPaid = 0;
  isWarehouseProductOrder = false;
  impressAssignOrderObjectLink = environment.assignOrderlog
  timezone: string = new Date().toString().split("(")[new Date().toString().split("(").length - 1].replace(/[^A-Z]+/g, "")

  constructor(private notification: NotificationService, private loader: LoaderService, private activatedRoute: ActivatedRoute,
    private route: Router, private orderService: OrderService, private dialog: MatDialog, private errorhandlerService: ErrorhandlerService,
    private http: HttpClient, private EncrDecr: EncrDecrService, private commonService: CommonService,
    private designHuddleImageService: DesignHuddleImageService) {
  }

  ngOnInit() {

    this.userRole = localStorage.getItem('role');
    this.userId = localStorage.getItem('userId');
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe(params => {
        this.parentRouteParam = params['storename'];
      });
    }
    this.activatedRoute.params.subscribe(params => this.orderid = params['orderid']);
    //this.orderid = Number(this.EncrDecr.encryptData('123456$#@$^@1ERF', this.orderid));
    this.activatedRoute.data.subscribe((res: any) => {
      this.fn_GetOrderDetail(res);
    }, (err: any) => {
    });
    // orderDetail is only populated inside fn_GetOrderDetail (and only when StatusCode === 200),
    // so guard against it being undefined here — an error response left this reading .OrderStatusId
    // off undefined and crashed ngOnInit.
    this.selectedValue = this.orderDetail ? this.orderDetail.OrderStatusId : this.selectedValue;
  }

  // Parse the Order.ShopifyDiscounts JSON string into a list of display strings ("code: amount (type)").
  getShopifyDiscounts(json: string): string[] {
    if (!json) return [];
    try {
      const obj = JSON.parse(json);
      return Object.keys(obj).map(k => {
        const d = obj[k];
        if (d && typeof d === 'object') {
          const label = [d.code, d.amount].filter(x => x != null).join(': ');
          return d.type ? `${label} (${d.type})` : label;
        }
        return String(d);
      });
    } catch {
      return [];
    }
  }

  getDate(date: string | number | Date,requiretimezone: any){
    if(requiretimezone){
    let options: Intl.DateTimeFormatOptions  = { hour12: false, day: 'numeric', month: 'long',  year: 'numeric',hour:'numeric',minute:'numeric',second:'numeric'};
    return new Date(date).toLocaleDateString("en-US", options) + " (" +this.timezone+")";
    }else{
      let options: Intl.DateTimeFormatOptions  = { hour12: false, weekday:'long', day: 'numeric', month: 'long',  year: 'numeric'};
    return new Date(date).toLocaleDateString("en-US", options);
    }
  }

  fn_GetOrderDetail(res: any) {

    if (res.orderDetail.StatusCode === 200) {
      //var shopifyProfit=res.orderDetail.S
      this.orderDetail = res.orderDetail.Data.ResponseData;
      this.selectedValue = this.orderDetail.OrderStatusId;
      // Capture the approved store-admin discount % BEFORE the code below overwrites orderDetail.Discount.
      this.isSopHosted = !!(this.orderDetail.storeOwner && this.orderDetail.storeOwner.SOPHosted);
      this.sopHostedDiscountPercent = Number(this.orderDetail.Discount) || 0;
      this.orderDeskNo = this.orderDetail.PostedOrderDeskId;
      this.isWarehouseProductOrder = this.orderDetail.OrderItems.length > 0 ?  this.orderDetail.OrderItems[0].IsWareHouseProduct : false;
      if (this.orderDetail.OrderStatus === 'Dispatched') {
        this.orderDetail.OrderStatus = 'Shipped';
      }
      if (this.orderDetail.OrderItems.length > 0) {
        for (let i = 0; i < this.orderDetail.OrderItems.length; i++) {

          if (this.orderDetail.OrderItems[i].ItemStatus === 'Dispatched') {
            this.orderDetail.OrderItems[i].ItemStatus = 'Shipped';
          }
          if (!this.orderDetail.OrderItems[i].ImageName) {
            // Check Design Huddle first
            if (this.orderDetail.OrderItems[i].AzureBlobThumbnailUrl) {
              this.orderDetail.OrderItems[i].ImageName = this.orderDetail.OrderItems[i].AzureBlobThumbnailUrl;
            } else {
              this.orderDetail.OrderItems[i].ImageName = this.orderDetail.OrderItems[i].PngRelativeUrlWithProduct;
            }
          }

          if (this.orderDetail.IsOrderDeskOrder) {
            this.orderDetail.OrderItems[i].UnitPrice = this.orderDetail.OrderItems[i].UnitPrice + this.orderDetail.OrderItems[i].TotalPrintPrice;
            this.orderDetail.Discount = this.orderDetail.SubTotal * this.orderDetail.Discount / 100;
          }
          else {
            var finalCost = 0;
            var profit = 0;
            var cost = this.orderDetail.OrderItems[i].EmbroideryCost;
            var finishingPrice = this.orderDetail.OrderItems[i].FinishingPrice;
            var sideCount = this.orderDetail.OrderItems[i].ProductSidesCount;
            var IsEmbroideryType = this.orderDetail.OrderItems[i].IsEmbroideryType;
            if (this.orderDetail.IsSampleOrder === true) {
              // if embroidery true           
              if (IsEmbroideryType)
                finalCost = this.commonService.fn_CalculateTotalCost(this.orderDetail.OrderItems[i].UnitPriceWithoutProfit, finishingPrice, cost, sideCount, profit, IsEmbroideryType);
              else
                finalCost = this.commonService.fn_CalculateTotalCost(this.orderDetail.OrderItems[i].UnitPriceWithoutProfit, finishingPrice, this.orderDetail.PrintingCost, this.orderDetail.OrderItems[i].ProductSidesCount, profit);

              //Apply discount if has any
              if (this.orderDetail.OrderItems[i].Discount > 0 && this.orderDetail.OrderItems[i].Discount != null) {
                finalCost = this.commonService.fn_calculateDiscount(finalCost, this.orderDetail.OrderItems[i].Discount)

              }
            }

            else {
              profit = this.orderDetail.OrderItems[i].RetailPrice;
              if (!this.orderDetail.IsShopifyOrder) {
                // if embroidery true           
                if (IsEmbroideryType) {
                  finalCost = finalCost = this.commonService.fn_CalculateTotalCost(this.orderDetail.OrderItems[i].UnitPriceWithoutProfit, finishingPrice, cost, sideCount, profit, IsEmbroideryType);
                } else {
                  finalCost = this.commonService.fn_CalculateTotalCost(this.orderDetail.OrderItems[i].UnitPriceWithoutProfit, finishingPrice, this.orderDetail.PrintingCost, sideCount, profit, false, this.orderDetail.OrderItems[i].IsWareHouseProduct )
                }
              }
              else {
                // Include the store profit / retail price in the displayed cost for Shopify orders too
                // (was profit = 0, which showed the cost without profit).
                profit = this.orderDetail.OrderItems[i].RetailPrice;
                // if embroidery true
                if (IsEmbroideryType) {
                  // Pass finishingPrice as the 2nd arg (was missing) so args line up with the
                  // signature (unitprice, finishingCost, printCost, sideCount, profit, IsEmbroidery).
                  // Previously the embroidery cost was passed into the finishingCost slot and added
                  // UNCONDITIONALLY, so a single-side embroidery item still got +EmbroideryCost.
                  // With the correct order it becomes cost * (sideCount - 1): 0 for one side, added for 2+.
                  finalCost = this.commonService.fn_CalculateTotalCost(this.orderDetail.OrderItems[i].UnitPriceWithoutProfit, finishingPrice, cost, sideCount, profit, IsEmbroideryType);
                } else {
                  finalCost = this.commonService.fn_CalculateTotalCost(this.orderDetail.OrderItems[i].UnitPriceWithoutProfit, finishingPrice, this.orderDetail.PrintingCost, sideCount, profit,false,this.orderDetail.OrderItems[i].IsWareHouseProduct);
                }

                // NOTE: do NOT apply the item Discount (DiscountForStoreAdmin) for Shopify orders. That
                // field is the store-admin commission %, not a customer discount; applying it (e.g. 100%)
                // zeroed the displayed item cost / subtotal even though the order's real SubTotal is non-zero.

              }


            }
            this.shopifyTotal += finalCost * this.orderDetail.OrderItems[i].Quantity;
            this.orderDetail.OrderItems[i].UnitPrice = finalCost;
          }
        };
        if (!this.orderDetail.IsOrderDeskOrder) {
          this.orderDetail.Discount = this.shopifyTotal * this.orderDetail.Disccount / 100 ;
          this.shopifyTotal += Number(this.orderDetail.ShippingCost);
          // Sales tax is shown as a separate line and is included in the Total (Amount Paid).
          this.shopifyTotal += Number(this.orderDetail.SalesTaxAmount || 0);
          this.storeId = this.orderDetail.OrderItems[0].StoreId;
        }
      }
      // SOP-hosted discount summary: Amount Paid, then approved discount (% of Amount Paid), then Total.
      this.amountPaid = this.orderDetail.IsShopifyOrder ? this.shopifyTotal : Number(this.orderDetail.TotalPrice || 0);
      this.sopHostedDiscountAmount = this.amountPaid * this.sopHostedDiscountPercent / 100;
      this.sopHostedFinalTotal = this.amountPaid - this.sopHostedDiscountAmount;
      // this.orderlog = this.orderDetail.OrderLogs;
      this.loader.hide();

    } else if (res.orderDetail.StatusCode === 400) {
      this.notification.error(res.orderDetail.Message, 'Error');
      this.route.navigate(['/404NotFound']);
      this.loader.hide();
    } else {
      this.notification.error(res.orderDetail.Message, 'Error');
      this.route.navigate(['/404NotFound']);
      this.loader.hide();
    }
  }

  /** open review dialog */
  openRatingReviewDialog(ProductId: any, OrderNo: any, CustomizedProductId: any): void {
    const dialog = this.dialog.open(RatingReviewDialogComponent, {
      disableClose: true,
      width: '550px',
      data: { ProductId, OrderNo, CustomizedProductId }
    });
    dialog.afterClosed().subscribe((res: any) => {
    });
  }

  /**Till here */
  /** Fucn to update the order status */
  fn_UpdateOrderStatus(event: any) {
    // if (event === 5) {
    //   this.fn_fulfillment(this.storeId, this.orderDetail.OrderNo);
    // }
    // this.loader.show();
    // this.orderid = Number(this.EncrDecr.get(CryptoKeyValue.Key, String(this.orderid)));
    // this.orderService.UpdateOrder(this.userId, this.orderid, event, '').subscribe((res: any) => {
    //   if (res.StatusCode === 200) {
    //     this.loader.hide();
    //     this.route.navigate(['superadmin/orderdetail', this.orderDetail.OrderNo]);
    //   } else if (res.StatusCode === 400) {
    //     this.notification.error(res.Message, 'Error');
    //     this.loader.hide();
    //   } else {
    //     this.notification.error(res.Message, 'Error');
    //     this.loader.hide();
    //   }
    // }, (err: any) => {
    //   this.loader.hide();
    //   this.errorhandlerService.handleError(err);
    // });
  }

  fn_fulfillment(storeId: any, orderId: any) {
    this.http.get<any>(environment.baseUrl + '/Client/GetStoreById?storeid=' + storeId).subscribe((res: any) => {
      if (res.Data.ResponseData.apikey) {

        const dialogRef = this.dialog.open(TrackingPopupComponent);
        dialogRef.afterClosed().subscribe((resultDailog: any) => {

          const dataPost = {
            'mainAppOrder': orderId,
            'number': resultDailog.number,
            'url': resultDailog.url
          };
          this.http.post<any>(environment.baseUrlShopifyApp + '/api/product/fullfillment', dataPost, {
            headers: {
              'x-api-key': res.Data.ResponseData.apikey
            }
          }).subscribe((data) => {

          });
        });
      }
    });
  }

  RequestCancelOrder() {
    const dialogConfig: MatDialogConfig = {
      width: '600px',
      data: this.orderDetail
    };
    const orderCancelDialog = this.dialog.open(OrderCancelComponent, dialogConfig);
    orderCancelDialog.afterClosed().subscribe((res: any) => {
      if (res && res.isSubmit) {
        this.loader.show();
        this.ngOnInit();
      }
    });
  }

  requestSubmitOrderToOrderDesk(data:any) {

    this.orderId = data;
    this.orderService.requestSubmitOrderToOrderDesk(this.orderId).subscribe((res) => {
      if (res.StatusCode === 200) {
    this.orderDeskNo = res.Data.ResponseData.order.id;
    this.notification.success('Success', res.Message);
      } else if (res.StatusCode === 204) {
        this.notification.error('Error', res.Message);
      }
      else if (res.StatusCode === 400) {
        this.notification.error('Error', res.Message);
      }
      else{
        this.notification.error('Error', res.Message);
      }
    }, (err: any) => {
     
    });
  
  }

  requestRegenerateArtworkNo(CustomizedProductid:any, OrderNo:any ) {
    this.loader.show();
    var customizedProductid = CustomizedProductid;
    var orderNo = OrderNo
    this.orderService.requestRegenerateArtworkNo(customizedProductid, orderNo).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.loader.hide();
    var artWorkNo = res.Data.ResponseData;
     this.fn_changeArtworkNumberInOrderDetail(artWorkNo, customizedProductid );
    this.notification.success('Success', res.Message);
      } else if (res.StatusCode === 204) {
        this.loader.hide();
        this.notification.error('Error', res.Message);
      }
      else{
        this.loader.hide();
        this.notification.error('Error', res.Message);
      }
    }, (err: any) => {
     
    });
  
  }
  fn_changeArtworkNumberInOrderDetail(artWorkNo: any, customizedProductid: any) {
   
    // Check if orderDetail and its orderItem array exist
    if (this.orderDetail && this.orderDetail.OrderItems) {
      // Find the object in the array where CustomizedId matches the parameter
      const item = this.orderDetail.OrderItems.find((OrderItems: any) => OrderItems.CustomizedProductid === customizedProductid);
  
      if (item) {
        // Update the EmbDesignCode property
        item.EmbDesignCode = artWorkNo;
        console.log('Updated item:', item);
      } else {
        console.log('No matching item found for CustomizedId:', customizedProductid);
      }
    } else {
      console.log('orderDetail or orderItem array is not defined');
    }
  }

  /**Redireect user to view store screen */
  fn_ViewProduct(productId: any, designId: any, type: number) {
    var encryptedproductId = this.EncrDecr.set(CryptoKeyValue.Key, String(productId))
    var encrypteddesignId = this.EncrDecr.set(CryptoKeyValue.Key, String(designId))
    if (this.userRole == 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember')
      this.route.navigate(['/store/product/details'], { queryParams: { pid: encryptedproductId, designId: encrypteddesignId, type: type } });
    else
      this.route.navigate([this.parentRouteParam + '/product/details'], { queryParams: { pid: encryptedproductId, designId: encrypteddesignId, type: type } });
  }


  fn_ShowReportOrder(order: any) {
    // if order status is Shipped or Delivered, report is not submitted before and Shipped date not exceeded 60 days (Dates are in UTC)
    if (((order.OrderStatusId === 5 || order.OrderStatusId === 7) && !order.ReportOrderStatus) && order.DispatchedDate
      && this.commonService.fn_CalculateDateDiff(new Date().valueOf(), new Date(order.DispatchedDate).getTime()) <= Constants.ReportOrderWithinDays)
      return true;
    else
      false;
  }
  fn_ReportOrderStatus(order: any) {
    if (order.ReportOrderStatus) {
      const status = ReportOrderRequestStatus[order.ReportOrderStatus];
      return 'Report order ' + status;
    }
  }

  fn_ReportOrder(order: any) {
    const dialogConfig: MatDialogConfig = {
      width: '600px',
      data: order
    };
    this.dialog.open(ReportOrderComponent, dialogConfig);
  }
  getColor(order: any) {
    switch (order.ReportOrderStatus) {
      case 1:
        return '#17a2b8'; // blue
      case 2:
        return 'green';
      case 3:
        return 'red';
    }
  }
  fn_assignOrderObjectLink(orderNo: string, type: string){
    return this.impressAssignOrderObjectLink + orderNo + '_' + type + '.xml'
  }

  fn_ShowReportOrderReplacement(order: any) {
     //if order status is Shipped or Delivered, report is not submitted before and Shipped date not exceeded 60 days (Dates are in UTC)
     if (((order.OrderStatusId === 5 || order.OrderStatusId === 7) && !order.ReportOrderStatus) && order.DispatchedDate && (order.IsReplacementOrder == false || order.IsReplacementOrder == null)
       && this.commonService.fn_CalculateDateDiff(new Date().valueOf(), new Date(order.DispatchedDate).getTime()) <= Constants.ReportOrderWithinDays)
      return true;
     else
       false;
  }
  fn_ReportOrderStatusReplacement(order: any) {
    if (order.ReportOrderStatus) {
      const status = ReportOrderRequestStatus[order.ReportOrderStatus];
      return 'Report order ' + status;
    }
  }
  fn_ReportOrderReplacement(order: any) {
    const dialogConfig: MatDialogConfig = {
      width: '600px',
      data: order
    };
    this.dialog.open(ReportOrderComponent, dialogConfig);
  }

  getOrderItemImage(item: any): string {
    return this.designHuddleImageService.getCartItemImage(item);
  }

  handleTransactionDetail(transactionData: any, orderNo: any) {
    this.dialog.open(TransactionDetailDialogComponent, {
      width: '800px',
      data: {transactionData, orderNo}
    });
  }
}
